import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORKS,
	},
	getRegulationsStagesPlanWorkPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_PREVIEW,
	},
	getRegulationsStagesPlanWorkPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_POPUP,
	},
	getRegulationsStagesPlanWorkExtendedPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_EXTENDED_POPUP,
	},
	createRegulationsStagesPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].CREATE_REGULATIONS_STAGES_PLAN_WORK,
	},
	getRegulationsStagesPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK,
	},
	getRegulationsStagesPlanWorkDoneWorks: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_DONE_WORKS,
	},
	patchRegulationsStagesPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PATCH_REGULATIONS_STAGES_PLAN_WORK,
	},
	putRegulationsStagesPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PUT_REGULATIONS_STAGES_PLAN_WORK,
	},
	deleteRegulationsStagesPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].DELETE_REGULATIONS_STAGES_PLAN_WORK,
	},
}
